import axios from 'axios';
import { WEB_API_BASE_URL } from '../config/config';

// Use the Web API base URL from config
const WEBAPI_BASE_URL = WEB_API_BASE_URL;

interface EquipmentCustomerDetail {
  serialNumber?: string;
  customerNumber?: string;
  customerName?: string;
  customerAddress?: string;
  customerCity?: string;
  customerProvince?: string;
  customerPostalCode?: string;
  customerMobile?: string;
  equipmentType?: string;
  aliasName?: string;
  [key: string]: any;
}

class EquipmentService {
  /**
   * Get customer details by serial number from Equipment Master
   */
  async getCustomerDetailsBySerialNumber(serialNumber: string): Promise<EquipmentCustomerDetail | null> {
    try {
      const response = await axios.get(
        `${WEBAPI_BASE_URL}/Dropdown/GetListDataByModule`, 
        {
          params: {
            ModuleName: 'EquipmentMaster-SerialNumber-Customer-Detail',
            SerialNumber: serialNumber
          }
        }
      );

      if (response.data && response.data.Data && response.data.Data.ModelData) {
        const modelData = response.data.Data.ModelData;
        
        // If ModelData is an array, take the first item
        if (Array.isArray(modelData) && modelData.length > 0) {
          return modelData[0];
        }
        
        // If ModelData is an object, return it directly
        if (typeof modelData === 'object') {
          return modelData;
        }
      }
      
      return null;
    } catch (error) {
      console.error('Error fetching equipment customer details:', error);
      return null;
    }
  }

  /**
   * Validate serial number format
   */
  validateSerialNumberFormat(serialNumber: string): boolean {
    // Basic validation - adjust pattern as needed
    const pattern = /^[A-Z0-9]{6,20}$/i;
    return pattern.test(serialNumber);
  }
}

export default new EquipmentService();